const multiselectMainTemplate = `
<button type="button" tabindex="0" class="multiselect-open{{#selectDetails.isDisabled}} disabled{{/selectDetails.isDisabled}}{{selectDetails.classes}}">{{>buttonCaption}}</button>

{{#addSearch}}
<div class="multiselect-container-search">
  <input class="multiselect-container-search-input epsilon"
         type="text" data-select-name="{{selectDetails.name}}"
         {{#selectDetails.searchPlaceholder}}placeholder="{{selectDetails.searchPlaceholder}}"{{/selectDetails.searchPlaceholder}}
         tabindex="-1" />
  <div class="multiselect-container-search-status" data-text-no-results="Ei tuloksia."></div>
</div>
{{/addSearch}}

<div class="list-container{{selectDetails.classes}}">

  <ul class="{{#selectDetails.isMultiple}}multiple{{/selectDetails.isMultiple}}"
      data-select-name="{{selectDetails.name}}"
      {{#selectDetails.datasets}}data-{{datasetName}}="{{datasetValue}}"{{/selectDetails.datasets}}>
      {{>optionsList}}
  </ul>
  {{#selectDetails.isMultiple}}
    <button type="button" class="close-button exclude-legacy hidden btn btn--next-best-action">Valitse</button>
  {{/selectDetails.isMultiple}}
</div>
<button type="button" class="clear-selection btn exclude-legacy btn--second-best-action{{^showClearAll}} clear-selection-unactive{{/showClearAll}}">Tyhjennä</button>`;

const multiselectCaptionTemplate = `
  <span class="captions-titles {{#optionsSelected}}options{{/optionsSelected}}">
    {{#optionsSelected}}<span class="caption overline">{{defaultCaption}}</span>{{/optionsSelected}}
    {{#caption}}<span class="selected-option" data-caption="{{defaultCaption}}" {{#color}}style="--colorpicker:{{color}}" data-coloroutline="{{colorOutline}}"{{/color}}><span>{{.}}</span></span>{{/caption}}
    {{^caption}}<span class="selected-option">{{defaultCaption}}</span>{{/caption}}
  </span>
`;

const multiselectBavariaCaptionTemplate = `
  <span class="{{#optionsSelected}}options{{/optionsSelected}}">{{#caption}}<span data-caption="{{defaultCaption}}">{{.}}</span>{{/caption}}{{^caption}}{{defaultCaption}}{{/caption}}</span>
`;

const multiselectOptionTemplates = `
{{#options}}
{{#isCaption}}
  <li class="separator epsilon bold {{#hidden}}hidden{{/hidden}} {{classes}}" data-separator-label="{{shownValue}}" data-separator="true"{{#datasets}} data-{{{datasetName}}}="{{datasetValue}}"{{/datasets}}>{{shownValue}}</li>
{{/isCaption}}
{{^isCaption}}
  <li class="{{#selected}}selected{{/selected}} {{#hidden}}hidden{{/hidden}} group-option {{#underOptionGroup}}option-group-option{{/underOptionGroup}}" {{#color}}style="--colorpicker:{{color}}"{{/color}} data-value="{{{value}}}" data-shown-value="{{{shownValue}}}"{{#datasets}} data-{{{datasetName}}}="{{datasetValue}}"{{/datasets}} tabindex="-1" >
    <span>{{shownValue}}</span>
  </li>
{{/isCaption}}
{{/options}}
`;

const multiselectAdditionalTemplates = `
{{#options}}
<option value="{{{value}}}"{{#selected}} selected{{/selected}}{{#datasets}} data-{{{datasetName}}}="{{datasetValue}}"{{/datasets}}>{{shownValue}}</option>
{{/options}}
`;

export default {
  multiselectMainTemplate,
  multiselectCaptionTemplate,
  multiselectOptionTemplates,
  multiselectAdditionalTemplates,
  multiselectBavariaCaptionTemplate
}

export {
  multiselectMainTemplate,
  multiselectCaptionTemplate,
  multiselectOptionTemplates,
  multiselectAdditionalTemplates,
  multiselectBavariaCaptionTemplate
}
